import { getApiUrl } from "@/utils/apiConfig";
import { encodeWafPayload } from "@/utils/apiUtils";
export interface ModerationHistoryEntry {
  id: number;
  entity_id: string;
  entity_type: 'PARTNER' | 'PARTY';
  action_type: 'REJECT' | 'REQUIRE_PROOF' | 'APPROVE' | 'PARTNER_REACTION';
  message: string | null;
  document_url: string | null;
  created_at: string;
}

export const fetchModerationHistory = async (entityId: string): Promise<ModerationHistoryEntry[]> => {
  try {
    const token = localStorage.getItem("kaynin_auth_token");
    if (!token) return [];
    
    const res = await fetch(`${getApiUrl()}/moderation_history.php?entityId=${encodeURIComponent(entityId)}`, {
      headers: { "Authorization": `Bearer ${token}` }
    });
    
    if (!res.ok) return [];
    return await res.json();
  } catch (e) {
    console.error("Error fetching moderation history", e);
    return [];
  }
};

export const addModerationEntry = async (
  entityId: string, 
  entityType: 'PARTNER' | 'PARTY', 
  actionType: 'REJECT' | 'REQUIRE_PROOF' | 'APPROVE' | 'PARTNER_REACTION', 
  message: string = '', 
  documentUrl: string | null = null
): Promise<boolean> => {
  try {
    const token = localStorage.getItem("kaynin_auth_token");
    if (!token) return false;
    
    const payload = encodeWafPayload({
      entityId,
      entityType,
      actionType,
      message,
      documentUrl
    });

    const res = await fetch(`${getApiUrl()}/moderation_history.php`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "text/plain"
      },
      body: payload
    });
    
    return res.ok;
  } catch (e) {
    console.error("Error adding moderation entry", e);
    return false;
  }
};

export interface SupportTicket {
  id: number;
  user_id: string;
  user_role: string;
  subject: string;
  message: string;
  document_url: string | null;
  status: 'pending' | 'resolved' | 'closed';
  admin_response: string | null;
  created_at: string;
  updated_at: string;
}

export const fetchSupportTickets = async (): Promise<SupportTicket[]> => {
  try {
    const token = localStorage.getItem("kaynin_auth_token");
    if (!token) return [];
    
    const res = await fetch(`${getApiUrl()}/support.php`, {
      headers: { "Authorization": `Bearer ${token}` }
    });
    
    if (!res.ok) return [];
    return await res.json();
  } catch (e) {
    console.error("Error fetching support tickets", e);
    return [];
  }
};

export const createSupportTicket = async (subject: string, message: string, documentUrl: string | null = null): Promise<boolean> => {
  try {
    const token = localStorage.getItem("kaynin_auth_token");
    if (!token) return false;
    
    const payload = encodeWafPayload({
      action: 'create_ticket',
      subject,
      message,
      documentUrl
    });

    const res = await fetch(`${getApiUrl()}/support.php`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "text/plain"
      },
      body: payload
    });
    
    return res.ok;
  } catch (e) {
    console.error("Error creating support ticket", e);
    return false;
  }
};

export const resolveSupportTicket = async (ticketId: number, adminResponse: string): Promise<boolean> => {
  try {
    const token = localStorage.getItem("kaynin_auth_token");
    if (!token) return false;
    
    const payload = encodeWafPayload({
      action: 'resolve_ticket',
      ticketId,
      adminResponse
    });

    const res = await fetch(`${getApiUrl()}/support.php`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "text/plain"
      },
      body: payload
    });
    
    return res.ok;
  } catch (e) {
    console.error("Error resolving support ticket", e);
    return false;
  }
};

export const archiveSupportTicket = async (ticketId: number): Promise<boolean> => {
  try {
    const token = localStorage.getItem("kaynin_auth_token");
    if (!token) return false;
    
    const payload = encodeWafPayload({
      action: 'archive_ticket',
      ticketId
    });

    const res = await fetch(`${getApiUrl()}/support.php`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "text/plain"
      },
      body: payload
    });
    
    return res.ok;
  } catch (e) {
    console.error("Error archiving support ticket", e);
    return false;
  }
};

export const deleteSupportTicket = async (ticketId: number): Promise<boolean> => {
  try {
    const token = localStorage.getItem("kaynin_auth_token");
    if (!token) return false;
    
    const payload = encodeWafPayload({
      action: 'delete_ticket',
      ticketId
    });

    const res = await fetch(`${getApiUrl()}/support.php`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "text/plain"
      },
      body: payload
    });
    
    return res.ok;
  } catch (e) {
    console.error("Error deleting support ticket", e);
    return false;
  }
};
